// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"7c56b52e","536":"350909f6","941":"0176ca33"}[chunkId] + ".chunk.js";
};